import {createContext, ReactElement} from "react";

interface IAdsByGoogle {
    push: (member: any) => {}
}

interface IAdInstance {
    adBreak: (options: {}) => void,
    adConfig: (options: {}) => void,
    installed: boolean
    ready: boolean
}

const AdsByGoogle: IAdsByGoogle = (window as any).adsbygoogle = (window as any).adsbygoogle || [];
const AdInstance: IAdInstance = {
    adBreak: (o) => {
        AdsByGoogle.push(o);
    },
    adConfig: (o) => {
        AdsByGoogle.push(o);
    },
    installed: false,
    ready: false
};
const AdContext = createContext(AdInstance);

interface IAdProvider {
    children: ReactElement | ReactElement []
}

function AdProvider({children}: IAdProvider) {
    AdInstance.adConfig({
        preloadAdBreaks: "on",
        onReady: () => {
            console.log("Google ads ready");
            AdInstance.ready = true;
        }
    });
    return (
        <AdContext.Provider value={AdInstance}>
            <>
                {children}
            </>
        </AdContext.Provider>
    );
}

export {AdContext, AdProvider};